"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldWidgetBodyBeHiddenByDefault = exports.getAutoSelector = exports.getDefaultTextValues = exports.mergeWidgetMapData = exports.mergeWidgetData = exports.evalPageType = void 0;
const universal_utils_1 = require("@ecocart/universal-utils");
const unique_selector_1 = __importDefault(require("unique-selector"));
const dom_1 = require("./dom");
const params_1 = require("./params");
const shopify_1 = require("./shopify");
const titleHas = (str) => {
    var _a, _b;
    return (_b = (_a = document === null || document === void 0 ? void 0 : document.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(str);
};
const evalPageType = () => {
    if (window.location.href.includes('/cart')) {
        return 'cart';
    }
    if (window.location.href.includes('/checkout') || window.location.href.includes('/orders/')) {
        const step = (0, params_1.extractParamValueFromUrl)('step') || (0, shopify_1.getShopifyCheckoutStep)();
        if (step === 'contact_information' || titleHas('information')) {
            return 'checkout_contact_information';
        }
        if (step === 'shipping_method' || titleHas('shipping')) {
            return 'checkout_shipping_method';
        }
        if (step === 'payment_method' || titleHas('payment')) {
            return 'checkout_payment_method';
        }
        if (step === 'thank_you' || titleHas('thank you')) {
            return 'checkout_complete';
        }
        return 'checkout_unknown';
    }
    if (window.location.href.includes('/products')) {
        return 'product';
    }
    return 'in_store';
};
exports.evalPageType = evalPageType;
/* -------------------------------- widgetUI -------------------------------- */
const mergeWidgetData = (widgetMap, widgetPlacements) => {
    return (widgetPlacements || []).map((widgetPlacement) => (0, universal_utils_1.merge)(widgetPlacement, widgetMap === null || widgetMap === void 0 ? void 0 : widgetMap[widgetPlacement === null || widgetPlacement === void 0 ? void 0 : widgetPlacement.widgetKey]));
};
exports.mergeWidgetData = mergeWidgetData;
const mergeWidgetMapData = (widgetMap, widgetPlacements) => {
    return (Object.entries(widgetMap) || []).map(([key, widget]) => {
        const placement = widgetPlacements.find((p) => p.widgetKey === key);
        return Object.assign(Object.assign(Object.assign({}, placement), widget), { widgetKey: key });
    });
};
exports.mergeWidgetMapData = mergeWidgetMapData;
/* ----------------------------- template - text ---------------------------- */
const getDefaultTextValues = (template, merchant) => {
    switch (template) {
        case 'three': // ~ Standard (PDP)
            return {
                header: (0, universal_utils_1.t)('info_carbonNeutralOption'),
                header_complete: '',
                subHeader: '',
                tooltip: (0, universal_utils_1.t)('template_byDonating'),
                modalCta: (0, universal_utils_1.t)('template_addToMake')
            };
        case 'four': // ~ Charles redesign: https://www.figma.com/file/5XpjOgAOJXN2IXdyrTel6F/V2-Widget?node-id=406%3A9105
            switch (merchant === null || merchant === void 0 ? void 0 : merchant.payorMode) {
                case 'merchant_paying':
                    return {
                        header: (0, universal_utils_1.t)('template_madeCarbonNeutralBy'),
                        header_complete: '',
                        subHeader: '',
                        tooltip: (0, universal_utils_1.t)('template_brandIsProudMerchantPaying'),
                        modalCta: ''
                    };
                case 'customer_matching':
                    return {
                        header: (0, universal_utils_1.t)('template_brandIsMaking'),
                        header_complete: '',
                        subHeader: (0, universal_utils_1.t)('template_addToMatch'),
                        tooltip: (0, universal_utils_1.t)('template_brandIsProudCustomerMatching'),
                        modalCta: (0, universal_utils_1.t)('template_addToDouble')
                    };
                case 'merchant_matching':
                    return {
                        header: (0, universal_utils_1.t)('template_addToMake'),
                        header_complete: '',
                        subHeader: (0, universal_utils_1.t)('template_brandWillMatch'),
                        tooltip: (0, universal_utils_1.t)('template_byDonatingMatch'),
                        modalCta: (0, universal_utils_1.t)('template_addToReduce')
                    };
                case 'merchant_as_fallback_with_threshold':
                case 'merchant_as_fallback':
                case 'customer_paying':
                default:
                    return {
                        header: (0, universal_utils_1.t)('template_carbonNeutralOrderFor'),
                        header_complete: '',
                        subHeader: '',
                        tooltip: (0, universal_utils_1.t)('template_byDonating'),
                        modalCta: (0, universal_utils_1.t)('template_addToReduce')
                    };
            }
        case 'seven':
            return {
                header: (0, universal_utils_1.t)('template_impact'),
                header_complete: '',
                subHeader: '',
                footer: '',
                tooltip: '',
                modalCta: ''
            };
        case 'impact_counter':
            return {
                header: (0, universal_utils_1.t)('template_weHaveOffset'),
                header_complete: '',
                subHeader: (0, universal_utils_1.t)('template_wePartneredWithEcocart'),
                footer: '',
                tooltip: '',
                modalCta: '',
                cta: (0, universal_utils_1.t)('template_shopSustainably'),
                cta2: (0, universal_utils_1.t)('template_learnMore')
            };
        case 'education_touchpoint':
            return {
                header: (0, universal_utils_1.t)('template_yourOrderWillOffsetAmountCarbon'),
                header_complete: '',
                subHeader: (0, universal_utils_1.t)('template_byCheckingOutWithEcocartYourOrderWillHelp'),
                footer: '',
                tooltip: '',
                modalCta: '',
                cta: '',
                cta2: ''
            };
        case 'order_protection_checkout':
            return {
                header: (0, universal_utils_1.t)('shipping_protection'),
                header_complete: '',
                subHeader: (0, universal_utils_1.t)('loss_damage_theft_protection'),
                footer: '',
                tooltip: '',
                modalCta: '',
                cta: '',
                cta2: ''
            };
        case 'simple_checkout':
            return {
                header: (0, universal_utils_1.t)('add_price_for'),
                subHeader: (0, universal_utils_1.t)('sustainable_shipping')
            };
        case 'checkout_widget':
            switch (merchant === null || merchant === void 0 ? void 0 : merchant.payorMode) {
                case 'merchant_matching':
                    return {
                        header: (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2
                            ? (0, universal_utils_1.t)('template_makeMyOrderClimatePositive')
                            : (0, universal_utils_1.t)('template_offsetMyOrdersFootprint'),
                        header_complete: '',
                        subHeader: (0, universal_utils_1.t)('template_merchantWillDoubleTheImpactByMatching'),
                        tooltip: '',
                        modalCta: (0, universal_utils_1.t)('cta_learnMore'),
                        modal_subheader: (0, universal_utils_1.t)('template_ecocartPartnersWithCertifiedProjects')
                    };
                case 'merchant_paying':
                    return {
                        header: (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2
                            ? (0, universal_utils_1.t)('template_merchantMadeYourOrderClimatePositive')
                            : (0, universal_utils_1.t)('template_merchantOffsetYourCarbonFootprint'),
                        header_complete: '',
                        subHeader: (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2
                            ? (0, universal_utils_1.t)('template_merchantWillOffsetTwiceAsMuchCarbonAsYourOrderEmits')
                            : (0, universal_utils_1.t)('template_merchantWillOffsetYourOrdersCarbonFootprint'),
                        tooltip: '',
                        modalCta: (0, universal_utils_1.t)('cta_learnMore'),
                        modal_subheader: (0, universal_utils_1.t)('template_ecocartPartnersWithCertifiedProjects')
                    };
                case 'customer_matching':
                    return {
                        header: (0, universal_utils_1.t)('template_makeMyOrderClimatePositive'),
                        header_complete: '',
                        subHeader: (0, universal_utils_1.t)('template_merchantIsOffsettingYourOrdersCarbonFootprintMatchTheirContributionDouble'),
                        tooltip: '',
                        modalCta: (0, universal_utils_1.t)('cta_learnMore'),
                        modal_subheader: (0, universal_utils_1.t)('template_ecocartPartnersWithCertifiedProjects')
                    };
                case 'merchant_as_fallback_with_threshold':
                case 'merchant_as_fallback':
                case 'customer_paying':
                default:
                    return {
                        header: (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2
                            ? (0, universal_utils_1.t)('template_makeMyOrderClimatePositive')
                            : (0, universal_utils_1.t)('template_offsetMyOrdersFootprint'),
                        header_complete: '',
                        subHeader: (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2
                            ? (0, universal_utils_1.t)('template_offsetTwiceAsMuchCarbonAsYourOrderEmits')
                            : (0, universal_utils_1.t)('template_offsetEstimatedCo2e'),
                        tooltip: '',
                        modalCta: (0, universal_utils_1.t)('cta_learnMore'),
                        modal_subheader: (0, universal_utils_1.t)('template_ecocartPartnersWithCertifiedProjects')
                    };
            }
        case 'promo':
            switch (merchant === null || merchant === void 0 ? void 0 : merchant.payorMode) {
                case 'merchant_matching':
                    return {
                        header: (0, universal_utils_1.t)('template_offsetYourOrderAtCheckoutWith')
                    };
                case 'merchant_paying':
                    return {
                        header: (0, universal_utils_1.t)('template_merchantHasOffsetYourOrderWith')
                    };
                case 'customer_matching':
                    return {
                        header: (0, universal_utils_1.t)('template_offsetYourOrderAtCheckoutWith')
                    };
                case 'merchant_as_fallback_with_threshold':
                case 'merchant_as_fallback':
                case 'customer_paying':
                default:
                    return {
                        header: (0, universal_utils_1.t)('template_offsetYourOrderAtCheckoutWith')
                    };
            }
        case 'eco_incentives':
            switch (merchant === null || merchant === void 0 ? void 0 : merchant.payorMode) {
                // Copy not confirmed for this mode
                case 'merchant_matching':
                    return {
                        header: '',
                        subheader_in_progress: '',
                        subheader_complete: ''
                    };
                case 'merchant_paying':
                    return {
                        header: (0, universal_utils_1.t)('template_werePlantingTreesOnOrders'),
                        subheader_in_progress: (0, universal_utils_1.t)('template_youreValueAwayFromPlantingTrees'),
                        subheader_complete: (0, universal_utils_1.t)('template_hoorayYourOrderWillPlantTreesMerchantWillAlsoOffset')
                    };
                // Copy not confirmed for this mode
                case 'customer_matching':
                    return {
                        header: '',
                        subheader_in_progress: '',
                        subheader_complete: ''
                    };
                case 'merchant_as_fallback_with_threshold':
                case 'merchant_as_fallback':
                case 'customer_paying':
                default:
                    return {
                        header: (0, universal_utils_1.t)('template_werePlantingTreesOnOrders'),
                        subheader_in_progress: (0, universal_utils_1.t)('template_youreValueAwayFromPlantingTrees'),
                        subheader_complete: (0, universal_utils_1.t)('template_hoorayYourOrderWillPlantTreesMaximizeImpact')
                    };
            }
        case 'impact_receipt':
            return {
                header: (0, universal_utils_1.t)('template_yourOrderWillOffsetAmountCarbon'),
                subHeader: (0, universal_utils_1.t)('template_brandHasPartneredWithEcocart'),
                footer: (0, universal_utils_1.t)('template_yourContributionAtWork')
            };
        case 'enhanced_pdp':
            return {
                header: (0, universal_utils_1.t)('purchasing_this_will_offset_amount_carbon'),
                subHeader: (0, universal_utils_1.t)('this_is_like')
            };
        default:
            return {
                header: '',
                subHeader: '',
                tooltip: '',
                modalCta: ''
            };
    }
};
exports.getDefaultTextValues = getDefaultTextValues;
/* ---------------------------------- auto ---------------------------------- */
const ecoUnique = (el) => {
    return (0, unique_selector_1.default)(el) || el.id || el.getAttribute('name') || el.className;
};
const getAutoSelector = (pageType) => {
    const btns = Array.from(document.querySelectorAll('button,a'));
    let textId;
    switch (pageType) {
        case 'checkout_contact_information':
            textId = 'continuetoshipping';
            break;
        case 'checkout_shipping_method':
            textId = 'continuetopayment';
            break;
        case 'checkout_payment_method':
            textId = 'pay';
            break;
        case 'product':
            textId = 'addto';
            break;
        default:
            textId = 'checkout';
            break;
    }
    const btn = btns.find((el) => {
        return el.innerText.replace(/ /g, '').toLowerCase().includes(textId) && (0, dom_1.isElementViewable)(el);
    });
    if (!btn) {
        //append to parent node
        const inputs = Array.from(document.querySelectorAll('input'));
        const submits = inputs.filter((input) => {
            return input.getAttribute('type') === 'submit';
        });
        const checkoutBtn = submits.find((el) => {
            return el.getAttribute('name') === 'checkout';
        });
        if (!checkoutBtn)
            return 'step__footer';
        return ecoUnique((checkoutBtn === null || checkoutBtn === void 0 ? void 0 : checkoutBtn.parentElement) || checkoutBtn);
    }
    return ecoUnique(btn.parentElement || btn);
};
exports.getAutoSelector = getAutoSelector;
// if Customer Paying / Merchant Paying mode, body copy in the widget should be turned off by default for carbon neutral clients
const shouldWidgetBodyBeHiddenByDefault = (merchant) => {
    if ((merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) && (merchant === null || merchant === void 0 ? void 0 : merchant.offsetMultiplier) >= 2)
        return false;
    return ['customer_paying', 'merchant_paying', 'merchant_as_fallback_with_threshold', 'merchant_as_fallback'].includes(merchant.payorMode);
};
exports.shouldWidgetBodyBeHiddenByDefault = shouldWidgetBodyBeHiddenByDefault;
